import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  contenido: {
    padding: theme.spacing(2),
  },
  acciones: {
    margin: 0,
    padding: theme.spacing(1),
  },
}));

export default styles;
